
const routes = [
  {
    path: '/my-rsvt',
    redirect: { name: 'MyRsvtList' },
    meta: { layout: 'default', requiresAuth: true },
    children: [
      // 마이페이지 예약내역
      {
        path: 'list',
        name: 'MyRsvtList',
        meta: { layout: 'default', menu: 'my-rsvt', requiresAuth: true },
        component: () => import('@/pages/myRsvt/MyRsvtListView.vue'),
      },
      {
        path: 'detail/:type',
        name: 'MyRsvtDetail',
        meta: { layout: 'default', menu: 'my-rsvt', requiresAuth: true },
        component: () => import('@/pages/myRsvt/MyRsvtDetailContainer.vue'),
        props: true
      }
    ]
  },
  {
    path: '/my-old-rsvt',
    redirect: { name: 'OldRsvtList' },
    meta: { layout: 'default', requiresAuth: true },
    children: [
      // (구)예약내역
      {
        path: 'list',
        name: 'OldRsvtList',
        meta: { layout: 'default', menu: 'my-rsvt', requiresAuth: true },
        component: () => import('@/pages/oldRsvt/OldRsvtListView.vue'),
      },
      {
        path: 'detail/:type',
        name: 'OldRsvtDetail',
        meta: { layout: 'default', menu: 'my-rsvt', requiresAuth: true },
        component: () => import('@/pages/oldRsvt/OldRsvtDetailContainer.vue'),
        props: true
      }
    ]
  }
]

export default routes


